import React, { AnchorHTMLAttributes, MouseEvent, createRef } from 'react';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { Icon } from '../../Icon';

import styles from '../styles.module.css';

export interface CardAppointmentTriggerProps
  extends AnchorHTMLAttributes<HTMLAnchorElement> {
  label?: React.ReactNode;
  active?: boolean;
  onToggle: (id: string) => void;
}

export const CardAppointmentTrigger: React.FC<CardAppointmentTriggerProps> = ({
  children,
  href,
  label,
  active = false,
  onToggle,
  ...props
}) => {
  const anchorRef = createRef<HTMLAnchorElement>();

  function handleClick(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    onToggle(anchorRef.current!.parentElement!.id);
  }

  return (
    <a
      href={href}
      className={styles.cardTrigger}
      onClick={handleClick}
      ref={anchorRef}
      {...props}
    >
      <header className={styles.cardHeader}>{children}</header>

      <div className={styles.cardHeaderLabelContainer}>
        {label && <span className={styles.cardHeaderLabel}>{label}</span>}

        <Icon
          icon={MdOutlineKeyboardArrowDown}
          className={`${styles.cardArrowIcon} ${active ? styles.active : ''}`}
          size={28}
        />
      </div>
    </a>
  );
};
